//src/pages/admin/ui.js
import styled from 'styled-components';
import React from 'react';

/* ===== Общие UI-компоненты ===== */

export const Grid = styled.div`
  display:grid; gap:14px; grid-template-columns: 3fr 2fr; align-items:start;
  @media (max-width: 1100px){ grid-template-columns: 1fr; }
`;

export const Card = styled.div`
  background: var(--card); 
  border: 1px solid var(--bdr); 
  border-radius: 16px; 
  box-shadow: var(--shadow); 
  padding: 20px;
  
  h3 { 
    margin: 0 0 16px; 
    font-size: 18px;
    font-weight: 600;
    color: var(--fg);
  }
  
  h4 {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 600;
    color: var(--fg);
  }
`;

export const Row2 = styled.div`
  display:grid; gap:10px; grid-template-columns:1fr 1fr;
  @media(max-width: 720px){ grid-template-columns: 1fr; }
`;

export const Row3 = styled.div`
  display:grid; gap:10px; grid-template-columns:1fr 1fr 1fr;
  @media(max-width: 940px){ grid-template-columns: 1fr 1fr; }
  @media(max-width: 680px){ grid-template-columns: 1fr; }
`;

export const Field = styled.label`
  display:grid; gap:6px; font-size:14px;
  small{ opacity:.7; }
  
  input, select, textarea { 
    width:100%; 
    font: inherit;
    font-size: 16px;
    line-height: 1.5;
    background: var(--card);
    color: var(--fg);
    border: 1px solid var(--bdr);
    border-radius: 12px;
    padding: 12px 14px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    
    &:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 3px ${({theme}) => theme.primary}20;
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      background: ${({theme}) => theme.name === 'dark' ? 'rgba(255,255,255,.02)' : 'rgba(0,0,0,.02)'};
    }
    
    &::placeholder {
      color: var(--muted);
      opacity: 0.7;
    }
  }
  
  textarea { 
    min-height: 120px; 
    resize: vertical; 
    font-family: inherit;
  }
  
  select {
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    padding-right: 40px;
    appearance: none;
  }
`;

export const Actions = styled.div` display:flex; gap:10px; flex-wrap:wrap; `;
export const Btn = styled.button`
  padding: 12px 16px; 
  border-radius: 12px; 
  border: 1px solid var(--bdr);
  background: ${p=>p.$kind==='primary' ? 'var(--primary)' : 'var(--card)'};
  color: ${p=>p.$kind==='primary' ? 'var(--primaryFg)' : 'inherit'};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    ${p=>p.$kind==='primary' ? '' : 'border-color: var(--primary);'}
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
  
  ${p=>p.$kind==='danger' ? `
    background: #ef4444;
    color: white;
    border-color: #dc2626;
    &:hover {
      background: #dc2626;
      border-color: #b91c1c;
    }
  ` : ''}
  
  ${p=>p.$kind==='success' ? `
    background: #10b981;
    color: white;
    border-color: #059669;
    &:hover {
      background: #059669;
      border-color: #047857;
    }
  ` : ''}
`;

export const Badge = styled.span`
  display: inline-flex; 
  align-items: center; 
  gap: 6px;
  padding: 6px 12px; 
  border-radius: 20px; 
  border: 1px solid var(--bdr); 
  background: var(--card); 
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  
  ${props => props.$variant === 'success' ? `
    background: #10b98120;
    border-color: #10b981;
    color: #059669;
  ` : ''}
  
  ${props => props.$variant === 'warning' ? `
    background: #f59e0b20;
    border-color: #f59e0b;
    color: #d97706;
  ` : ''}
  
  ${props => props.$variant === 'danger' ? `
    background: #ef444420;
    border-color: #ef4444;
    color: #dc2626;
  ` : ''}
  
  ${props => props.$variant === 'primary' ? `
    background: var(--primary)20;
    border-color: var(--primary);
    color: var(--primary);
  ` : ''}
`;

export const TableWrap = styled.div` 
  overflow: auto; 
  border: 1px solid var(--bdr); 
  border-radius: 12px; 
  background: var(--card);
`;

export const Table = styled.table`
  width: 100%; 
  border-collapse: collapse; 
  font-size: 14px; 
  min-width: 820px;
  
  th, td { 
    padding: 12px 16px; 
    border-bottom: 1px solid var(--bdr); 
    text-align: left; 
    vertical-align: top; 
  }
  
  th { 
    white-space: nowrap; 
    font-weight: 600; 
    color: var(--muted); 
    position: sticky; 
    top: 0; 
    background: var(--card);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  tbody tr {
    transition: background-color 0.2s ease;
    
    &:hover { 
      background: ${({theme}) => theme.name === 'dark' ? 'rgba(255,255,255,.03)' : 'rgba(176,141,87,.06)'}; 
    }
    
    &:last-child td {
      border-bottom: none;
    }
  }
`;

export const Paginator = styled.div` 
  display: flex; 
  align-items: center; 
  gap: 8px; 
  justify-content: flex-end; 
  padding-top: 16px; 
`;

export const PageBtn = styled.button`
  padding: 8px 12px; 
  border-radius: 8px; 
  border: 1px solid var(--bdr); 
  background: var(--card);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &[data-active="true"] { 
    background: var(--primary); 
    color: var(--primaryFg); 
    border-color: transparent; 
  }
  
  &:hover:not([data-active="true"]) {
    border-color: var(--primary);
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

/* ===== Хелперы/хуки ===== */

export function useDebounced(value, delay=400){
  const [v, setV] = React.useState(value);
  React.useEffect(()=>{ const id = setTimeout(()=>setV(value), delay); return ()=>clearTimeout(id); }, [value, delay]);
  return v;
}

export function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

/* ===== Специальные поля ===== */

// Переключатель Да/Нет
export const ToggleField = styled.div`
  display: inline-flex; 
  border: 1px solid var(--bdr); 
  border-radius: 10px; 
  overflow: hidden;
  
  button {
    padding: 8px 16px; 
    font-weight: 600; 
    cursor: pointer; 
    border: none; 
    background: transparent;
    transition: all 0.2s ease;
    
    &:not(:last-child) { 
      border-right: 1px solid var(--bdr); 
    }
    
    &[data-active="true"] {
      background: var(--primary);
      color: var(--primaryFg);
    }
    
    &[data-active="false"] {
      background: var(--card);
      color: inherit;
    }
    
    &:hover:not([data-active="true"]) {
      background: ${({theme}) => theme.name === 'dark' ? 'rgba(255,255,255,.05)' : 'rgba(0,0,0,.02)'};
    }
  }
`;

// Поле с иконкой
export const IconField = styled.div`
  position: relative;
  
  input {
    padding-left: 44px;
  }
  
  .icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--muted);
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
`;

// Группа полей в строку
export const FieldGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: end;
  
  > * {
    flex: 1;
  }
  
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

// Поле с валидацией
export const ValidatedField = styled(Field)`
  ${props => props.$error ? `
    input, select, textarea {
      border-color: #ef4444;
      box-shadow: 0 0 0 3px #ef444420;
    }
  ` : ''}
  
  .error-message {
    color: #ef4444;
    font-size: 12px;
    margin-top: 4px;
  }
`;

// Компонент переключателя Да/Нет
export function YesNoToggle({ value, onChange, disabled = false }) {
  const v = !!value;
  return (
    <ToggleField>
      <button 
        type="button" 
        data-active={v === true}
        onClick={() => !disabled && onChange(true)}
        disabled={disabled}
      >
        Да
      </button>
      <button 
        type="button" 
        data-active={v === false}
        onClick={() => !disabled && onChange(false)}
        disabled={disabled}
      >
        Нет
      </button>
    </ToggleField>
  );
}

/* ===== Сворачиваемые секции (аккордеон) ===== */
export function Collapse({ title, defaultOpen = false, children, right }){
  const [open, setOpen] = React.useState(!!defaultOpen);
  return (
    <Card style={{padding:0}}>
      <button
        type="button"
        onClick={()=>setOpen(o=>!o)}
        aria-expanded={open}
        style={{
          width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between',
          gap:10, padding:'12px 14px', background:'transparent', border:'none', cursor:'pointer'
        }}
      >
        <span style={{display:'flex', alignItems:'center', gap:10, fontWeight:800}}>
          <span style={{
            display:'inline-block', width:18, height:18, borderRadius:6, border:'1px solid var(--bdr)',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)', transition:'transform .15s ease',
            background: [
              'linear-gradient( to right, transparent 8px, var(--bdr) 8px, var(--bdr) 10px, transparent 10px )',
              'linear-gradient( to bottom, transparent 8px, var(--bdr) 8px, var(--bdr) 10px, transparent 10px )'
            ].join(', ')
          }}/>
          {title}
        </span>
        {right}
      </button>
      {open && (
        <div style={{padding:14, borderTop:'1px solid var(--bdr)'}}>
          {children}
        </div>
      )}
    </Card>
  );
}
